import { abbreviateName as abbreviate, setNationalParticipantBorder } from '@sportal365/smp-widget-utils';
import { assetsPlaceholder } from '../../../../constants/assetsPlaceholder';
import { CurrentServer, ParticipantTypes } from '../../../../constants/tennis';
import { INormalizedTennisParticipantDetails } from '../../../../types';
import { SMPImage, SMPSportEntity, SMPText, StyledSMPImageVariants } from '../../../index';

enum Winner {
  YES = 'YES',
  NO = 'NO',
}

type ISingleEventParticipantProps = {
  participantName: string;
  countryLogo?: string;
  participantLink?: string;
  participant?: INormalizedTennisParticipantDetails;
  handleParticipantClick?: (participantDetails: INormalizedTennisParticipantDetails) => void;
  urlTarget?: string;
  imageVariant?: StyledSMPImageVariants['variant'];
  winner?: string;
  sportEntityVariant?: string;
  isMobile?: boolean;
  showCurrentServer?: boolean;
  currentServer?: string;
  abbreviateName?: boolean;
};

export const MatchParticipant = ({
  participantName,
  countryLogo,
  participant,
  handleParticipantClick,
  participantLink,
  urlTarget,
  imageVariant,
  winner,
  sportEntityVariant,
  isMobile,
  showCurrentServer,
  currentServer,
  abbreviateName = false,
}: ISingleEventParticipantProps): JSX.Element => {
  return (
    <SMPSportEntity
      href={participantLink}
      target={urlTarget}
      onClick={() => handleParticipantClick && participant && handleParticipantClick(participant)}
      variant={sportEntityVariant === ParticipantTypes.TEAM_DOUBLE ? 'tennisTeamDouble' : { '@bp0': 'horizontal' }}
      css={{
        '@bp0': { width: '100%' },
        '@bp1': { width: isMobile ? '100%' : 'auto' },
      }}
    >
      {countryLogo && countryLogo !== '' ? (
        <SMPImage
          variant={imageVariant ? imageVariant : 'livescoreEntityLogo'}
          src={countryLogo}
          alt={participantName}
          css={{ br: '$round', ...setNationalParticipantBorder(true) }}
        />
      ) : null}
      <SMPText
        css={{
          overflow: 'visible',
          '@bp0': { maxWidth: '100%', whiteSpace: 'nowrap', pr: '$1' },
          '@bp1': { maxWidth: '100%', whiteSpace: isMobile ? 'nowrap' : 'pre-wrap' },
          '@bp2': { pr: isMobile ? '$2' : '0' },
        }}
        variant='tennisSingleEventLabel'
        size={isMobile ? '3' : { '@initial': '2', '@bp1': '3' }}
        weight={winner === Winner.YES ? '700' : '400'}
      >
        {abbreviateName ? abbreviate(participantName) : participantName}
      </SMPText>
      {showCurrentServer && currentServer && currentServer === CurrentServer.YES && sportEntityVariant !== ParticipantTypes.TEAM_DOUBLE ? (
        <SMPImage variant={'tennisParticipantServer'} src={assetsPlaceholder.tennisServer} alt={participantName} />
      ) : null}
    </SMPSportEntity>
  );
};
